import React from 'react';
import { Button, Checkbox, Field, FormLabel, Popup } from '@quickmd-llc/design-system';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (dontShowAgain: boolean) => void;
  /** True while the claim/start is in flight — disables the Start button to block double-submit. */
  isConfirming?: boolean;
};

export const ReadyToStartVisitPopup: React.FC<Props> = ({
  isOpen,
  onClose,
  onConfirm,
  isConfirming = false,
}) => {
  const [dontShowAgain, setDontShowAgain] = React.useState(false);

  return (
    <Popup
      isOpen={isOpen}
      onClose={onClose}
      showCloseIcon
      header="Ready to start this visit?"
      body={
        <Field className="flex cursor-pointer items-center gap-sp-1">
          <Checkbox checked={dontShowAgain} onChange={setDontShowAgain} />
          <FormLabel className="cursor-pointer font-semibold text-text-dark">
            Don’t show this confirmation again
          </FormLabel>
        </Field>
      }
      footer={
        <div className="flex justify-end gap-sp-1">
          <Button priority="secondary" onClick={onClose}>
            Go back
          </Button>
          <Button priority="primary" disabled={isConfirming} onClick={() => onConfirm(dontShowAgain)}>
            Start
          </Button>
        </div>
      }
    />
  );
};
